import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U2107, { U2107ROLES } from './U2107';
import U2107LogicalUnitCategoryList from './components/U2107LogicalUnitCategoryList';
import U2107LogicalUnitCategoryForm from './components/U2107LogicalUnitCategoryForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U2107Routes: RouteObject[] = [
  {
    path: 'U2107',
    element: <U2000RequireRole allowedRoles={[U2107ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U2107 />,
        children: [
          { index: true, element: <U2107LogicalUnitCategoryList /> },
          { path: ':id', element: <U2107LogicalUnitCategoryForm /> },
        ],
      },
    ],
  },
];

export default U2107Routes;
